import { useState } from 'react';
import { formatDate } from '../utils';
import Tooltip from './Tooltip';
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { IoLogoYoutube } from "react-icons/io";
import { FcFilm } from "react-icons/fc";
import { SiSpotify } from "react-icons/si";
import './ScoutingNotes.css';

const ScoutingNotes = ({ notes, isHE }: { notes: any[] | null; isHE: boolean }) => {
    const validatedNotes = notes || [];
    const [expandedNote, setExpandedNote] = useState<number | null>(null);

    const toggleNote = (idx: number) => {
        setExpandedNote(expandedNote === idx ? null : idx);
    };

    return (
        <ul className="list-none text-sm">
            {validatedNotes.map((note, idx) => (
                <li
                    key={idx}
                    className={`mt-3 mb-5 ${expandedNote === idx ? 'font-normal' : ''}`}
                    style={{ textAlign: isHE ? 'right' : 'left' }}
                >
                    <div className="flex items-center space-x-2 space-x-reverse">

                        <Tooltip
                            content={expandedNote === idx
                                ? isHE ? "צמצם" : "collapse"
                                : isHE ? "הרחב" : "expand"
                            }
                            position="bottom"
                        >
                            <button
                                onClick={() => toggleNote(idx)}
                                className="text-sm p-1 rounded-full bg-white/50 shadow-sm hover:bg-white/90 hover:scale-110 transition focus:outline-none"
                                aria-expanded={expandedNote === idx}
                            >
                                {expandedNote === idx ? <AiOutlineMinus /> : <AiOutlinePlus />}
                            </button>
                        </Tooltip>
                        <span>
                            {note.title}

                        </span>
                        <span className="flex items-center ml-4 space-x-2">
                            {
                                note.hasFilm &&
                                <Tooltip
                                    content={isHE ? "כולל סרטון" : "contains film"}
                                    position={isHE ? 'left' : 'right'}
                                >
                                    <FcFilm className="mt-0.5" />
                                </Tooltip>
                            }
                            {
                                note.resource[1]?.includes("youtu") &&
                                <Tooltip
                                    content={isHE ? "מהלך בולט" : "Highlighted Move"}
                                    position={isHE ? 'left' : 'right'}
                                >
                                    <IoLogoYoutube style={{ color: "#FF0033" }} className="mt-0.5" />
                                </Tooltip>
                            }


                            {note.resource[1]?.includes("spotify.com") && (
                                <SiSpotify style={{ color: "#1DD05D" }} className="mt-0.5" />
                            )}

                        </span>
                    </div>

                    {expandedNote === idx && (
                        <div className="mt-2 bg-white/40 rounded-xl ring-1 ring-[#7A4B4F]/10 shadow-sm p-3 animate-fade-in">
                            <span>
                                {note.content}
                            </span>
                            {note.resource[1] && (
                                <a
                                    href={note.resource[1]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="underline text-[#5A4638] hover:text-[#3E2F22] focus:text-[#3E2F22]"
                                >
                                    <br />
                                    {
                                        note.dateGiven ?
                                            (
                                                <div className='mt-1'>
                                                    {note.resource[0]}, {formatDate(note.dateGiven, isHE)}

                                                </div>
                                            ) : (
                                                <div className='mt-1'>
                                                    {note.resource[0]}
                                                </div>
                                            )
                                    }

                                </a>
                            )}
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default ScoutingNotes;

